import {FC} from 'react';
import {Terms} from '../../components/termsAndPolicy/Terms';

export const TermsOfUse: FC = () => {
    return <Terms/>;
};
